import script from "./TagListSdaa.vue?vue&type=script&setup=true&lang=js"
export * from "./TagListSdaa.vue?vue&type=script&setup=true&lang=js"

import "./TagListSdaa.vue?vue&type=style&index=0&id=63827ae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63827ae8"]])

export default __exports__